import React, { useEffect, useState } from "react";
import { CloudUpload, Trash2, Upload } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
    uploadPurchaseDocument,
    listPurchaseDocument,
    deletePurchaseDocument,
} from "@/redux/Purchase/actions";
import { showToast } from "@/redux/Toast/actions";
import CelebrationButton from "../ui/CelebrationButton/CelebrationButton";

const FileUpload = ({ orderId, orderNum, type }) => {
    const dispatch = useDispatch();
    const [documentType, setDocumentType] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [uploadLoading, setUploadLoading] = useState(false);
    const { isAnimate } = useSelector((state) => state.toast);

    const [authUser] = JSON.parse(localStorage.getItem('authUser') ?? "[{}]");

    const companyId = authUser?.companyId;
    const user = authUser?.firstName + ' ' + authUser?.lastName;

    const url = {
        purchase: {
            list: "v1/PurchaseOrder/GetPurchaseOrderDocsByID?PurchaseOrderID=",
            upload: "v1/PurchaseOrder/UploadPODocument",
            delete: "v1/PurchaseOrder/DeletePoDocs",
        },
        sales: {
            list: "v1/SalesOrder/GetSalesOrderDocsByID?SalesOrderID=",
            upload: "v1/SalesOrder/UploadSODocument",
            delete: "v1/SalesOrder/DeleteSoDocs",
        },
        loadplan: {
            list: "v1/LoadPlan/GetLoadPlanDocsByID?LoadPlanID=",
            upload: "v1/LoadPlan/UploadLPDocument",
            delete: "v1/LoadPlan/DeleteLPDocs",
        },
        booking: {
            list: "v1/Booking/GetBookingDocsByID?BookingID=",
            upload: "v1/Booking/UploadBookingDocument",
            delete: "v1/Booking/DeleteBookingDocs",
        },
        rateQuote: {
            list: "v1/RateQuote/GetRateQuoteDocsByID?RateQuoteID=",
            upload: "v1/RateQuote/UploadRQDocument",
            delete: "v1/RateQuote/DeleteRQDocs",
        },
        importRateQuote: {
            list: "v1/RateQuoteImport/GetImportRateQuoteDocsByID?ImportRateQuoteID=",
            upload: "v1/RateQuoteImport/UploadImportRQDocument",
            delete: "v1/RateQuoteImport/DeleteImportRateQuoteDocs",
        },
        ImportBooking: {
            list: "v1/Arrival_Import/GetBookingDocsByID?BOLID=",
            upload: "v1/Arrival_Import/UploadBookingDocument",
            delete: "v1/ImportBooking/DeleteImportBookingDocs",
        },
    };

    useEffect(() => {
        _getFileList();
    }, [orderId]);

    const _getFileList = () => {
        let payload = orderId;

        if (type === "ImportBooking") {
            payload = `${orderId}&CompanyID=${companyId}`;
        }

        setLoading(true);
        listPurchaseDocument(url[type].list, payload)
            .then((response) => {
                setLoading(false);
                console.log("File List:", response);
                if (response && response.statuscode === 200) {
                    setFileList(response.data || []);
                } else {
                    setFileList([]);
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    const _saveFile = () => {
        if (!documentType) {
            dispatch(showToast("Please select a document type.", "error"));
            return;
        }

        if (!selectedFile) {
            dispatch(showToast("Please select a file to upload.", "error"));
            return;
        }

        const formData = new FormData();
        if (type === "purchase") {
            formData.append("PurchaseOrderID", orderId);
            formData.append("PoNumber", orderNum);
        } else if (type === "sales") {
            formData.append("SalesOrderID", orderId);
            formData.append("SoNumber", orderNum);
        } else if (type === "loadplan") {
            formData.append("LoadPlanID", orderId);
            formData.append("LPNumber", orderNum);
        } else if (type === "booking") {
            formData.append("BookingID", orderId);
            formData.append("RefNo", orderNum);
        } else if (type === "rateQuote") {
            formData.append("RATEQUOTE_ID", orderId);
            formData.append("RATEQUOTE_NUMBER", orderNum);
        } else if (type === "importRateQuote") {
            formData.append("RATEQUOTE_ID", orderId);
            formData.append("RATEQUOTE_NUMBER", orderNum);
        }
        else if (type === "ImportBooking") {
            formData.append("BOLID", orderId);
            formData.append("CompanyID", companyId);
            formData.append("RefNo", orderNum);
        }
        formData.append("DocumentType", documentType);
        formData.append("FileData", selectedFile);
        formData.append("CreatedBy", "ADMIN");

        console.log("selectedFile:", selectedFile);
        setUploadLoading(true);
        uploadPurchaseDocument(url[type].upload, formData)
            .then((response) => {
                setUploadLoading(false);
                if (
                    response &&
                    (response.statuscode === 200 || response.statuscode === 201)
                ) {
                    dispatch(showToast("File uploaded successfully.'", "success", true));
                    setDocumentType("");
                    setSelectedFile(null);
                    _getFileList();
                } else {
                    dispatch(
                        showToast("Failed to upload file. Please try again.", "error"),
                    );
                    setDocumentType("");
                    setSelectedFile(null);
                }
            })
            .catch((error) => {
                setLsetUploadLoadingoading(false);
                dispatch(
                    showToast("An error occurred while uploading the file.", "error"),
                );
            });
    };

    const _deleteFile = (fileId) => {
        let payload = {
            id: fileId,
            modifiedBy: "PSR",
        };

        if (type === "ImportBooking") {
            payload = {
                id: fileId,
                CompanyID: companyId,
                ModifiedBy: user,
            };
        }

        setLoading(true);
        deletePurchaseDocument(url[type].delete, payload)
            .then((response) => {
                setLoading(false);
                if (
                    (response && response.statuscode === 200) ||
                    response.statuscode === 201
                ) {
                    dispatch(showToast("File deleted successfully.", "success"));
                    _getFileList();
                } else {
                    dispatch(
                        showToast("Failed to delete file. Please try again.", "error"),
                    );
                }
            })
            .catch((error) => {
                setLoading(false);
                dispatch(
                    showToast("An error occurred while deleting the file.", "error"),
                );
            });
    };

    return (
        <>
            <div className=" p-4">
                <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3">
                    Upload Documents
                </h2>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Document Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            value={documentType}
                            onChange={(e) => setDocumentType(e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-1 focus:ring-[#0072FF] focus:border-[#0072FF]"
                        >
                            <option value="">SELECT DOCUMENT TYPE</option>
                            <option value="invoice">Invoice</option>
                            <option value="packing">Packing List</option>
                            <option value="bol">Bill of Lading</option>
                            <option value="certificate">Certificate</option>
                            <option value="booking">Booking confirmation</option>
                            <option value="trucker">Trucker invoice</option>
                            <option value="email">Email</option>
                            <option value="insurance">Insurance certificate</option>
                            <option value="coo">COO</option>
                            <option value="other">Other</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-1">
                            Attach File <span className="text-red-500">*</span>
                        </label>
                        <div className="flex items-center space-x-2">
                            <div className="flex-1 relative">
                                <input
                                    type="file"
                                    onChange={(e) => setSelectedFile(e.target.files[0])}
                                    className="w-full px-3 py-2 text-sm border border-slate-300 dark:border-slate-700 rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-white file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:text-xs file:bg-slate-100 dark:file:bg-slate-700 file:text-slate-700 dark:file:text-slate-300 hover:file:bg-slate-200 dark:hover:file:bg-slate-600"
                                />
                                {!selectedFile && (
                                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-slate-400 pointer-events-none">
                                        No file selected.
                                    </span>
                                )}
                            </div>
                            <CelebrationButton
                                onClick={() => _saveFile()}
                                label={"Upload File"}
                                className="px-4 py-2 text-sm bg-[#0072FF] hover:bg-[#0062DD] text-white rounded-lg font-medium transition-all whitespace-nowrap"
                                isLoading={uploadLoading}
                                icon={<CloudUpload className="w-4 h-4" />}
                                isSuccess={isAnimate}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="p-4">  
            <h2 className="text-sm font-semibold text-slate-900 dark:text-white mb-3 ">
                    Uploaded Documents
                </h2>
            <div className="mt-4 bg-white dark:bg-slate-900 rounded-lg border border-slate-200 dark:border-slate-800 p-4 ">
                
                {fileList.length === 0 ? (
                    <tr>
                        <td colSpan={5}>
                            <p className="text-xs text-slate-500 dark:text-slate-400">
                                No documents uploaded yet.
                            </p>
                        </td>
                    </tr>
                ) : (
                    <>
                        <table className="w-full text-sm text-left text-slate-900 dark:text-white">
                            <thead>
                                <tr>
                                    <th className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                        Document Type
                                    </th>
                                    <th className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                        File Name
                                    </th>
                                    <th className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                        Uploaded On
                                    </th>
                                    <th className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                        Uploaded By
                                    </th>
                                    <th className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <p className="text-xs text-slate-500 dark:text-slate-400">
                                                Loading...
                                            </p>
                                        </td>
                                    </tr>
                                ) : fileList.length === 0 ? (
                                    <tr>
                                        <td colSpan={5}>
                                            <p className="text-xs text-slate-500 dark:text-slate-400">
                                                No documents uploaded yet.
                                            </p>
                                        </td>
                                    </tr>
                                ) : (
                                    fileList.map((file, index) => (
                                        <tr
                                            key={index}
                                            className="hover:bg-slate-100 dark:hover:bg-slate-800"
                                        >
                                            <td className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                                {file.documentType}
                                            </td>
                                            <td className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                                <a
                                                    href={file.filePath}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-indigo-400"
                                                >
                                                    {file.fileName}
                                                </a>
                                            </td>
                                            <td className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                                {moment(file.uploadedOn).format("DD-MM-YYYY")}
                                            </td>
                                            <td className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                                {file.createdBy}
                                            </td>
                                            <td className="px-3 py-2 border-b border-slate-200 dark:border-slate-800">
                                                <button
                                                    className="p-1 text-slate-500 hover:text-red-600 transition-colors"
                                                    title="Delete"
                                                    onClick={() => _deleteFile(file?.id)}
                                                >
                                                    <Trash2 className="w-4 h-4" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </>
                )}
            </div>
            </div>
        </>
    );
};

export default FileUpload;